<button
  mat-icon-button
  class="sm:!text-white"
  [matMenuTriggerFor]="notifications_menu"
  (click)="onOpenMenu()"
>
  <mat-icon
    [matBadge]="calculateRemindersCount()"
    matBadgeColor="warn"
    [attr.inert]="false"
    aria-label="Notifications"
    >notifications</mat-icon
  >
</button>

<mat-menu class="notifications-menu" #notifications_menu="matMenu">
  <mat-tab-group
    disablePagination="true"
    (click)="$event.stopPropagation()"
    (selectedIndexChange)="onTabChange($event)"
    [selectedIndex]="currentDay() === 'TODAY' ? 0 : 1"
  >
    <mat-tab
      label="{{ 'today' | translate }} ({{ unReadTodayRemindersCount || 0 }})"
    >
    </mat-tab>
    <mat-tab
      label="{{ 'tomorrow' | translate }} ({{
        unReadTomorrowRemindersCount || 0
      }})"
    >
    </mat-tab>
  </mat-tab-group>
  @if (reminders().length > 0 && !isLoading) {
    <ul class="notifications-menu__list">
      @for (reminder of reminders(); track reminder) {
        <li
          class="notifications-menu__item"
          (click)="reminder?.id && openDetailsDialog(reminder?.id)"
        >
          <app-notification-item
            [notificationData]="reminder"
          ></app-notification-item>
        </li>
      }
    </ul>
  }

  @if (reminders().length === 0 && !isLoading) {
    <div class="notifications-menu__empty-list-container">
      <p class="notifications-menu__empty-list-message">
        {{ "reminders.list.noReminderSubmitted" | translate }}
      </p>
    </div>
  }

  @if (isLoading) {
    <div class="p-2">
      @if (isLoading) {
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': placeholderStyles.inputBorderRadius,
            height: '30px',
            width: '100%',
            'background-color': placeholderStyles.backgroundColor,
            'margin-bottom': '-4px',
          }"
          appearance="line"
          [count]="4"
        ></ngx-skeleton-loader>
      }
    </div>
  }
</mat-menu>
